import React from 'react'
import styled from 'styled-components'
import Outer from '../../../../styles/outer/Outer'
import OverviewBGHidden from '../../../../assets/bg/mobile/bg_overview_hidden.png'
import OverviewBG from '../../../../assets/bg/mobile/bg_overview.png'
import Slide01 from '../../../../assets/bg/mobile/bg_overview_slide_01.png'
import Slide02 from '../../../../assets/bg/mobile/bg_overview_slide_02.png'
import Slide03 from '../../../../assets/bg/mobile/bg_overview_slide_03.png'
import { Section, Text, View } from '../../../../styles'
import Float from '../../../../styles/float/Float'
import CardTempBG from '../../../../assets/bg/mobile/bg_white_temp.png'

const OverviewMobileComponent = () => {
  return (
    <Wrap>
      <Outer>
        <img src={OverviewBGHidden} style={{ opacity: 0 }} />
        <Float>
          <StyledBG>
            <img src={OverviewBG} />
          </StyledBG>
        </Float>
        <Float top={'50%'}>
          <StyledSection slide spacing={-20}>
            <img src={Slide01} />
            <img src={Slide02} />
            <img src={Slide03} />
          </StyledSection>
        </Float>
      </Outer>
    </Wrap>
  )
}

export default OverviewMobileComponent

const Wrap = styled.div`
  margin-bottom: 10%;
`

const StyledBG = styled.div`
  margin-top: 17%;
  padding-left: 34px;
`
const StyledSection = styled(Section)`
  gap: unset;
  & > img {
    margin: 0 -15%;
  }
`
